<template>
    <div>
        <h1 class="fs-4 fw-bold text-dark mb-1 lh-sm">
            {{ authentication_user.active_store
                ? 'Promociones por lista de precio'
                : 'Promociones' }}
        </h1>
        <p class="text-muted small fw-medium">
            Activa o desactiva el estado de campaña promocional de los productos.
        </p>
        <TablePromocionesConfig
            @getData="getSearch"
            @change-page="changePage"
            @change-page-size="changePageSize"
            @viewModal="viewModal"
            @filterPromotionStatus="updatePromotionStatus"
            :products="productList"
            :loading="loading"
            :total-count="totalProducts"
            :current-page="currentPage"
            :page-size="pageSize"
        />
        <!-- Modal -->
        <modal-form
            v-if="propHead.open"
            :propSize="propForm.size"
            :propHead="propHead"
            @closeModal="closeModal"
        >
            <template slot="form">
                <component :is="componentName" :propHead="propHead" @refrest="refrest" @closeModal="closeModal"/>
            </template>
        </modal-form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import configsRecModuleMixin from '../mixins/configsRecModuleMixin';
import TablePromocionesConfig from './TablePromocionesConfig.vue';
import ModalForm from "../../../../../components/modal.vue";
import ConfigPromocionesOne from './configPromocionesOne.vue';
import ConfigPromocionesOptions from './configPromocionesOptions.vue';

export default {
    name: 'config-promociones',
    mixins: [configsRecModuleMixin],
    components: {
        TablePromocionesConfig,
        ModalForm,
        ConfigPromocionesOne,
        ConfigPromocionesOptions,
    },
    data() {
        return {
            propHead: {
                action: "",
                open: false,
                module: "promociones",
                text: ""
            },
            propForm: {
                size: "",
                form: "",
            },
            componentName: null,
            promotionStatus: '',
        };
    },
    methods: {
        ...mapActions(["executeCommit"]),
        buildUrl() {
            return `/api/products/list_config_promociones/?${this.buildCommonParams()}&prop_extra_3=VIGENTE&promotion_status=${this.promotionStatus}`;
        },
        viewModal(row, name, title, text) {
            this.componentName = name;
            this.propForm.size = false;
            this.propHead = {
                action: title,
                open: true,
                row: row,
                text: text,
                component: this.componentName,
            };
        },
        closeModal() {
            this.executeCommit({
                mutation: "close_modal",
            });
            this.propHead = {
                action: "",
                open: false,
                module: "promociones",
                text: ""
            };
            this.componentName = null;
        },
        refrest() {
            this.closeModal();
            this.fetchData();
        },
        updatePromotionStatus(status) {
            this.promotionStatus = status;
            this.fetchData();
        },
    }
};
</script>
